/**
 * Converts IDBValidKey to a string, taking into account all spec-compliant types.
 *
 * @see https://w3c.github.io/IndexedDB/#key-construct
 */

export function idbValidKeyToString(key: IDBValidKey): string {
  if (Array.isArray(key)) {
    return key.map((k) => idbValidKeyToString(k)).join("");
  }

  if (key instanceof Date) {
    return key.toString();
  }

  if (key instanceof ArrayBuffer || ArrayBuffer.isView(key)) {
    const decoder = new TextDecoder("utf-8");
    return decoder.decode(key);
  }

  return key.toString();
}
